import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { GUID, Strategy, StrategyCreateRequest, StrategyUpdateRequest } from '@ndvr/portfolio-api';

import { PortfolioApi } from 'API';

export const useListStrategies = () => {
    return useQuery({
        queryKey: ['strategies'],
        queryFn: async () => {
            const [response] = await PortfolioApi().getAssignableStrategies();
            return response ?? undefined;
        },
    });
};

export const useCreateStrategy = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (request: StrategyCreateRequest) => {
            const [response] = await PortfolioApi().createStrategy(request);
            return response ?? undefined;
        },
        onSuccess: () => {
            toast.success('Strategy created successfully');
            queryClient.invalidateQueries({ queryKey: ['strategies'] });
        },
        onError: (error) => toast.error('Failed to create strategy'),
    });
};

export const useUpdateStrategy = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
            strategyGUID,
            request,
        }: {
            strategyGUID: GUID<Strategy>;
            request: StrategyUpdateRequest;
        }) => {
            const [response] = await PortfolioApi().updateStrategy(strategyGUID, request);
            return response ?? undefined;
        },
        onSuccess: () => {
            toast.success('Strategy updated successfully');
            queryClient.invalidateQueries({ queryKey: ['strategies'] });
        },
        onError: (error) => toast.error('Failed to update strategy'),
    });
};

export const useDeleteStrategy = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (strategyGUID: GUID<Strategy>) => {
            const [response] = await PortfolioApi().deleteStrategy(strategyGUID);
            return response ?? undefined;
        },
        onSuccess: () => {
            toast.success('Strategy deleted successfully');
            queryClient.invalidateQueries({ queryKey: ['strategies'] });
        },
        onError: (error) => toast.error('Failed to delete strategy'),
    });
};
